const { createBundleTiles } = require('../../shop/tiles/product-tile-factory');
const { reduce } = require('lodash');

class ProductGroupTileListController {
    constructor(settings, analyticsService, productGroupService) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.productGroupService = productGroupService;
    }

    $onInit() {
        this.sortOptions = this.productGroupService.getSortOptions();
    }

    title() {
        const description = this.productGroupService.selectedGroup.Description;

        return this.productGroupService.selectedGroupTotalCount != null
            ? `${description} (${this.productGroupService.selectedGroupTotalCount})`
            : description;
    }

    createTiles(products) {
        return {
            items: createBundleTiles(products.items),
            totalRecordCount: products.totalRecordCount,
            aggregations: products.aggregations,
        };
    }

    getTiles(pageSize, pageNumber, sortType = 'Name', filters) {
        return this.productGroupService.selectProductGroup(this.productGroupId)
            .then(() => this.productGroupService.getProducts(pageSize, pageNumber, sortType, filters))
            .then(products => this.createTiles(products));
    }

    createAnalyticsData(contentData) {
        return {
            pageNumber: contentData.pageNumber,
            currentCategory: this.productGroupService.selectedGroup,
            products: reduce(contentData.items, (products, item) => {
                if (item.type === 'product') {
                    products.push({ Name: item.data.product.Name, Products: [item.data.product] });
                }
                return products;
            }, []),
            inspirationCards: { Cards: contentData.inspirationCards },
            totalRecordCount: this.productGroupService.selectedGroupTotalCount,
            filters: contentData.filters,
            sortType: contentData.sortType ? contentData.sortType.Value : '',
            sortOptions: this.sortOptions,
        };
    }

    pushContentDataToAnalytics(contentData) {
        this.analyticsService.push({
            data: this.createAnalyticsData(contentData),
            type: this.analyticsService.mapperTypes.shop.productCategory,
        });
    }
}

ProductGroupTileListController.$inject = ['Settings', 'AnalyticsService', 'ProductGroupService'];

const productGroupTileListComponentDefinition = {
    bindings: {
        productGroupId: '<?',
        pageNumber: '<',
        sortBy: '<',
        filter: '<',
        showSaveToList: '<?',
        enableNavigateToDetailPage: '<?',
    },
    controller: ProductGroupTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.title()"
            page-number="$ctrl.pageNumber"
            total-record-count="$ctrl.productGroupService.selectedGroupTotalCount"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            filter="$ctrl.filter"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType, filter)"
            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)"
            show-save-to-list="$ctrl.showSaveToList"
            enable-navigate-to-detail-page="$ctrl.enableNavigateToDetailPage">
        </wow-tile-list>
    `,
};

module.exports = {
    ProductGroupTileListController,
    productGroupTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/productgroups/productgroup-tile-list.component.js